import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import classNames from 'classnames';

const AuthLayout: React.FC = () => {
  const { mode } = useSelector((state: RootState) => state.theme);

  return (
    <div className={classNames('min-h-screen flex flex-col', {
      'bg-gray-100': mode === 'light',
      'bg-gray-900 text-gray-200': mode === 'dark'
    })}>
      <div className="flex flex-col min-h-screen">
        {/* Header */}
        {/* <header className="py-4 px-6 flex justify-center">
          <div className="flex items-center">
            <img
              src="/logo.svg"
              alt="Logo"
              className="h-8 w-8"
            />
            <h1 className="ml-3 text-xl font-semibold">SplashMe</h1>
          </div>
        </header> */}

        {/* Main content */}
        <main className="flex-grow flex items-center justify-center p-4">
          <div className={classNames('w-full max-w-md p-8 rounded-lg shadow-md', {
            'bg-white': mode === 'light',
            'bg-gray-800': mode === 'dark'
          })}>
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <footer className="py-4 px-6 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} SplashMe. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default AuthLayout; 